import styles from './BulletPointsResultCard.module.css';

type BulletPointsCardProps = {
  text: string;
};

export const BulletPointsResultCard = ({ text }: BulletPointsCardProps) => {
  return (
    <div className={styles.bulletPointsCard}>
      <h4 className={styles.bulletPointsCardHeading}>Result</h4>
      <p className={styles.bulletPointsCardText}>{text}</p>
    </div>
  );
};
